import request from '@/utils/request'
import { varConfig, ConstConfig } from '@/utils'
import { getToken } from '@/libs/cookie-storage'

export function getLiveBroadcastPlan(params) {
  return request({
    url: ConstConfig.apiPath + '/GetLiveBroadcastPricePlan.json',
    method: 'get',
    params
  })
}

export function createLiveBroadcastOrder(params) {
  return request({
    url: ConstConfig.apiPath + '/CreateLiveBroadcastOrder.json',
    method: 'get',
    params
  })
}

export function getBMUserLiveAccountBalanceInfo() {
  return request({
    url: ConstConfig.apiPath + '/GetBMUserLiveAccountBalanceInfo.json',
    method: 'get'
  })
}

export function getWPUnifiedOrder(params) {
  return request({
    url: ConstConfig.apiPath + '/GetWPUnifiedOrder.json',
    method: 'get',
    params
  })
}

export function loginWechat(params) {
  return request({
    url: ConstConfig.apiPath + '/LoginWechat.json',
    method: 'get',
    params
  })
}

export function getSKUListBySPU(params) {
  return request({
    url: ConstConfig.apiPath + '/GetSKUListBySPU.json',
    method: 'get',
    params
  })
}

export function createSmsOrder(params) {
  params.passport = getToken()
  return request({
    url: varConfig.camApi + ConstConfig.wxApiPath + '/CreateOrder.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/pay.js